/** @jsxImportSource @emotion/react */

interface Props {
  children?: React.ReactNode | React.ReactNode[];
  justifyContent?: string;
  alignItems?: string;
  sx?: React.CSSProperties;
}

/**
 * Simple flex container for easily adding rows in components
 * @param justifyContent normal css property put into props for easy accessibility
 * @param alignItems normal css property put into props for easy accessibility
 * @param sx optional css override. Takes a css object
 */
const Row = ({
  children = null,
  justifyContent = null,
  alignItems = null,
  sx = null,
}: Props) => (
  <div
    css={{
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: alignItems ?? 'baseline',
      justifyContent: justifyContent ?? 'space-evenly',
      width: '100%',
      lineHeight: '1',
      ...(sx ? { ...sx } : {}),
    }}
  >
    {children}
  </div>
);

export default Row;
